(function ($) {
    /**
     * Plugin jQuery dsHeader pour créer un header avec une navigation responsive
     * @param {Object} options - Options de configuration
     * @param {boolean} [options.loacale="fr"] - langue utilisée pour les messages
     * @param {Object} [options.messages] - messages affichées par le plugin
     */
    $.fn.dsHeader = function (options) {
        // Configuration par défaut
        const settings = $.extend(true, {
            locale: "fr", // langue utilisée pour les messages
            messages: { // messages affichées par le plugin
                en: {
                    showMenu: "Show navigation menus",
                    hideMenu: "Hide navigation menus",
                    closePanel: "Close submenu"
                },
                fr: {
                    showMenu: "Afficher les menus de navigation",
                    hideMenu: "Masquer les menus de navigation",
                    closePanel: "Fermer le sous-menu"
                }
            }
        }, options || {});

        // Point de rupture pour le mode desktop
        const desktopBreakpoint = 1280;

        // Classes CSS utilisées par le plugin
        const navElements = {
            dropdownClass: 'dropdown',
            accordionClass: 'accordion',
            menuClass: 'm-header__menu',
            navTriggerClass: 'm-header__nav-trigger',
            navWrapperClass: 'm-header__nav-wrapper',
            navClass: 'm-header__nav',
            subnavClass: 'm-header__subnav',
            subnavItemClass: 'm-header__subnavbar-item',
            subnavLabelClass: 'm-header__subnavbar-item-label',
            subnavPanelClass: 'm-header__subnavbar-item-panel',
            subnavCloseButtonClass: 'm-header__subnavbar-item-close'
        };

        const locale = settings.locale || 'en'; // Fallback vers 'en' si settings.locale est undefined

        // Fonction pour générer un UUID
        function uuid() {
            return 'xxxxyxxx'.replace(/[xy]/g, function (c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }

        // Fonction pour activer désactiver le lien courant en fonction de l'url
        function updateActiveLink($nav, forceRemove = false) {
            const $links = $nav.find('a');
            const currentPath = window.location.pathname.replace(/\/$/, ''); // ignore trailing slash

            $links.each(function () {
                const $link = $(this);
                const linkPath = new URL($link.attr('href'), window.location.origin).pathname.replace(/\/$/, '');

                if (forceRemove) {
                    $link.removeClass('-active');
                } else if (linkPath === currentPath) {
                    $link.addClass('-active').attr('aria-current', 'page');
                } else {
                    $link.removeClass('-active').removeAttr('aria-current');
                }
            });
        }

        // Helper pour récupérer les éléments focusables
        function getFocusableElements($container) {
            // Sélecteur recommandé par le WAI‑ARIA
            const focusableSelector = [
                'a[href]',
                'area[href]',
                'input:not([disabled]):not([type="hidden"])',
                'select:not([disabled])',
                'textarea:not([disabled])',
                'button:not([disabled])',
                'iframe',
                'object',
                'embed',
                '[contenteditable]',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');

            return $container.find(focusableSelector).filter(':visible');
        }

        // Fonction qui crée le trap‑focus
        function enableFocusTrap(state) {
            const $focusable = getFocusableElements(state.navWrapper);
            if ($focusable.length === 0) return;

            const first = $focusable.first();
            const last = $focusable.last();

            // Met le focus sur le premier élément focusable du menu
            first.focus();

            // Gestion du cycle Tab / Shift+Tab
            state.navWrapper.on('keydown.focusTrap', function (e) {
                if (e.key !== 'Tab') return;

                // Tab depuis le dernier élément : focus sur le trigger
                // Shift+Tab depuis le premier élément : focus sur le trigger
                if ((!e.shiftKey && $(document.activeElement).is(last))
                    || (e.shiftKey && $(document.activeElement).is(first))) {
                    e.preventDefault();
                    state.navTrigger.focus();
                    return;
                }
            });
        }

        // Désactive le trap‑focus
        function disableFocusTrap(state) {
            state.navWrapper.off('keydown.focusTrap');
        }

        // Fonction de debounce pour les événements resize
        function debounce(func, wait) {
            let timeout;
            return function () {
                const context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    func.apply(context, args);
                }, wait);
            };
        }

        // Mise à jour de la disposition
        function updateLayout(state) {
            const newIsDesktop = window.innerWidth >= desktopBreakpoint;

            if (newIsDesktop !== state.isDesktop) {
                state.isDesktop = newIsDesktop;
                if (newIsDesktop) {
                    convertToDesktop.call(this, state);
                } else {
                    convertToMobile.call(this, state);
                }
            }
        }

        // Conversion en mode desktop (dropdowns)
        function convertToDesktop(state) {
            // Détruire les instances d'accordion existantes
            state.collapseInstances.forEach(instance => instance.collapse('dispose'));
            state.collapseInstances = [];

            // Supprimer les événements
            state.navTrigger.off('click.dsHeader');

            // Nettoyage des ajouts ARIA/ID/classes
            state.navWrapper.removeClass('show');
            state.navWrapper.removeAttr('aria-labelledby');
            const wrapperId = state.navWrapper.attr('id');
            if (wrapperId && wrapperId.includes(state.uuid)) {
                state.navWrapper.removeAttr('id');
            }

            state.navTrigger.removeAttr('aria-expanded aria-controls');
            state.navTrigger.find('.icon').removeClass('icon-close').addClass('icon-burger');
            state.navTrigger.find('.icon__label').text(settings.messages[locale].showMenu);
            const triggerId = state.navTrigger.attr('id');
            if (triggerId && triggerId.includes(state.uuid)) {
                state.navTrigger.removeAttr('id');
            }

            let hasOpenItem = false;

            state.navWrapper.find(`.${navElements.subnavItemClass}`).each(function (index) {
                const $item = $(this);
                const $label = $item.find(`.${navElements.subnavLabelClass}`);
                const $panel = $item.find(`.${navElements.subnavPanelClass}`);
                const labelId = $label.attr('id') || `label-${state.uuid}-${index}`;
                const panelId = $panel.attr('id') || `panel-${state.uuid}-${index}`;

                // Supprimer les classes d'accordion
                $item.removeClass(navElements.accordionClass);
                $label.removeAttr('data-target');
                $label.removeClass('collapsed');
                $panel.removeClass('collapse');

                // Configurer les ARIA attributes
                $label.attr('id', labelId);

                if ($panel.length) {
                    // Ajouter les classes de dropdown
                    if (!hasOpenItem && $panel.hasClass('show')) {
                        $item.addClass(`${navElements.dropdownClass} show`);
                    } else {
                        $item.addClass(`${navElements.dropdownClass}`);
                    }


                    $label.attr({
                        'data-toggle': 'dropdown',
                        'aria-haspopup': 'true',
                        'aria-expanded': (!hasOpenItem && $panel.hasClass('show')) ? 'true' : 'false',
                        'aria-controls': panelId
                    });

                    $panel.attr({
                        'id': panelId,
                        'aria-labelledby': labelId
                    });

                    $panel.addClass('dropdown-menu');

                    // Créer une nouvelle instance de dropdown
                    let dropdownInstance;
                    if (!hasOpenItem && $panel.hasClass('show')) {
                        dropdownInstance = $label.dropdown('show');
                        hasOpenItem = true;
                    } else {
                        dropdownInstance = $label.dropdown('hide');
                    }
                    state.dropdownInstances.push(dropdownInstance);

                    // Gérer le clic sur le bouton de fermeture
                    $item.find(`.${navElements.subnavCloseButtonClass}`).off('click.dsHeader').on('click.dsHeader', function () {
                        $label.dropdown('toggle');
                    });
                }
            });

            // Gestion du menu overlay
            state.menu.toggleClass('show', state.subnav.find('.dropdown.show').length > 0);
            $('body').toggleClass('has-nav-open', state.subnav.find('.dropdown.show').length > 0);

            // Au moment où le dropdown s’ouvre, on ajoute les classes
            // sur le <body> et sur le menu principal.
            $(`.${navElements.dropdownClass}`).on('show.bs.dropdown', function () {
                $('body').addClass('has-nav-open');
                state.menu.addClass('show');
            });

            // Au moment où le dropdown se ferme, on retire les classes
            // uniquement s’il n’y a plus aucun dropdown ouvert.
            $(`.${navElements.dropdownClass}`).on('hide.bs.dropdown', function () {
                $('body').removeClass('has-nav-open');
                state.menu.removeClass('show');
            });

            // Display subnav
            state.subnav.addClass('show');
        }

        // Conversion en mode mobile (accordions)
        function convertToMobile(state) {
            // Détruire les instances de dropdown existantes
            state.dropdownInstances.forEach(instance => instance.dropdown('dispose'));
            state.dropdownInstances = [];

            // Clean subnav
            state.subnav.removeClass('show');

            // Supprimer les événements
            state.navWrapper.find(`.${navElements.subnavCloseButtonClass}`).off('click.dsHeader');

            const wrapperId = state.navWrapper.attr('id') || `nav-wrapper-${state.uuid}`;
            const triggerId = state.navTrigger.attr('id') || `nav-trigger-${state.uuid}`;
            if (state.navTrigger.length) {
                state.navTrigger.attr('aria-expanded', 'false');
                state.navTrigger.attr('aria-controls', wrapperId);
                state.navTrigger.find('.icon').removeClass('icon-close').addClass('icon-burger');
                state.navTrigger.find('.icon__label').text(settings.messages[locale].showMenu);

                if (!state.navTrigger.attr('id')) {
                    state.navTrigger.attr('id', triggerId);
                }

                // Attacher le gestionnaire de clic au trigger
                state.navTrigger.off('click.dsHeader').on('click.dsHeader', function () {
                    toggleMenu.call(this, state, state.navTrigger.attr('aria-expanded') !== 'true');
                });
            }

            if (state.navWrapper.length) {
                state.navWrapper.attr('aria-labelledby', triggerId);

                if (!state.navWrapper.attr('id')) {
                    state.navWrapper.attr('id', wrapperId);
                }
            }

            state.navWrapper.find(`.${navElements.subnavItemClass}`).each(function (index) {
                const $item = $(this);
                const $label = $item.find(`.${navElements.subnavLabelClass}`);
                const $panel = $item.find(`.${navElements.subnavPanelClass}`);
                const labelId = $label.attr('id') || `label-${state.uuid}-${index}`;
                const panelId = $panel.attr('id') || `panel-${state.uuid}-${index}`;

                // Supprimer les classes de dropdown
                $item.removeClass(`${navElements.dropdownClass} show`);
                $label.removeAttr('aria-haspopup');
                $panel.removeClass('dropdown-menu');

                // Configurer les ARIA attributes
                $label.attr('id', labelId);

                if ($panel.length) {
                    // Ajouter les classes d'accordion
                    $item.addClass(navElements.accordionClass);
                    $label.attr({
                        'data-toggle': 'collapse',
                        'aria-expanded': $panel.hasClass('show') ? 'true' : 'false',
                        'aria-controls': panelId,
                        'data-target': `#${panelId}`
                    });

                    $panel.attr({
                        'id': panelId,
                        'aria-labelledby': labelId
                    });

                    $panel.addClass('collapse');

                    // Créer une nouvelle instance de collapse
                    const collapseInstance = $panel.collapse($panel.hasClass('show') ? 'show' : 'hide');
                    state.collapseInstances.push(collapseInstance);
                }
            });

            // Gestion du menu overlay
            if ($('body').hasClass('has-nav-open')) {
                toggleMenu.call(this, state, true);
            }
        }

        // Fonction pour ouvrir et fermer la navigation en mobile
        function toggleMenu(state, willOpen) {
            // Sauvegarde la position du scroll
            if (!willOpen) {
                state.scrollTop = state.navWrapper.scrollTop();
            }
            // toggle la classe « show » sur le menu et le wrapper
            $('body').toggleClass('has-nav-open', willOpen);
            state.menu.toggleClass('show', willOpen);
            state.navWrapper.toggleClass('show', willOpen);
            state.navTrigger.find('.icon')
                .toggleClass('icon-close', willOpen)
                .toggleClass('icon-burger', !willOpen);
            state.navTrigger.find('.icon__label').text(willOpen ? settings.messages[locale].hideMenu : settings.messages[locale].showMenu);

            // mettre à jour aria‑expanded du bouton
            state.navTrigger.attr('aria-expanded', willOpen);

            // gestion du focus
            if (willOpen) {
                // On attend la fin de la transition (opacity, visility ou transform)
                const onTransitionEnd = function (e) {
                    if (!['opacity', 'transform'].includes(e.originalEvent.propertyName)) return;
                    state.navWrapper.off('transitionend.focusTrap', onTransitionEnd);
                    enableFocusTrap(state);

                    // Restore la position du scroll
                    state.navWrapper.scrollTop(state.scrollTop);
                };

                state.navWrapper.on('transitionend.focusTrap', onTransitionEnd);
            } else {
                disableFocusTrap(state);
                state.navTrigger.focus();
            }
        }

        // Initialisation
        function init() {
            const $header = $(this).first();

            // Si déjà initialisé, ne rien faire
            if ($header.data('dsHeaderInitialized')) {
                return;
            }

            const uuidValue = uuid();

            // Menu
            const $menu = $header.find(`.${navElements.menuClass}`).first();

            // Menu trigger
            const $navTrigger = $header.find(`.${navElements.navTriggerClass}`).first();

            // Nav wrapper
            const $navWrapper = $header.find(`.${navElements.navWrapperClass}`).first();

            // Nav
            const $nav = $header.find(`.${navElements.navClass}`).first();

            // Subnav
            const $subnav = $header.find(`.${navElements.subnavClass}`).first();

            // Nav Header
            const headerId = $header.attr('id') || `header-${uuidValue}`;
            if ($header.length && !$header.attr('id')) {
                $header.attr('id', headerId);;
            }

            // Panneau de sous-menu
            $navWrapper.find(`.${navElements.subnavCloseButtonClass} .icon__label`).text(settings.messages[locale].closePanel);
            
            // Initialiser l'état
            let state = {
                uuid: uuidValue,
                dropdownInstances: [],
                collapseInstances: [],
                header: $header,
                menu: $menu,
                navWrapper: $navWrapper,
                navTrigger: $navTrigger,
                nav: $nav,
                subnav: $subnav,
                scrollTop: 0   
            };

            // Initialiser en fonction de la taille de l'écran
            updateLayout.call(this, state);

            // Defini le lien actif au chargement de la page
            updateActiveLink($nav);

            // mouseenter : désactive temporairement le style du lien actif
            $nav.on('mouseenter.dsHeader', function () {
                updateActiveLink($nav, true);
            });

            // mouseleave : restore le style du lien actif
            $nav.on('mouseleave.dsHeader', function () {
                updateActiveLink($nav);
            });

            // Gérer les événements de resize
            const debouncedResize = debounce(function () {
                updateLayout.call(this, state);
                // Fin du redimensionnement : suppression de la classe resizing
                state.subnav.removeClass('resizing');
            }, 100);

            $(window).on(`resize.dsHeader-${uuidValue}`, function () {
                // Début du redimensionnement : ajout de la classe resizing
                state.subnav.addClass('resizing');
                debouncedResize.call(this);
            });

            // API publique
            const api = {
                /**
                 * Détruit le plugin et nettoie les événements
                 */
                destroy: function () {
                    if (!state) return;

                    // Détruire les instances Bootstrap
                    state.dropdownInstances.forEach(instance => instance.dropdown('dispose'));
                    state.collapseInstances.forEach(instance => instance.collapse('dispose'));

                    // Supprimer les événements
                    $(window).off(`resize.dsHeader-${state.uuid}`);
                    state.nav.off('mouseenter.dsHeader');
                    state.nav.off('mouseleave.dsHeader');
                    state.navTrigger.off('click.dsHeader');
                    state.navWrapper.find(`.${navElements.subnavCloseButtonClass}`).off('click.dsHeader');

                    // Nettoyage des ajouts ARIA/ID/classes
                    $('body').removeClass('has-nav-open');

                    const headerId = state.header.attr('id');
                    if (headerId && headerId.includes(state.uuid)) {
                        state.header.removeAttr('id');
                    }

                    state.menu.removeClass('show');
                    state.navWrapper.removeClass('show');
                    state.navWrapper.removeAttr('aria-labelledby');
                    const wrapperId = state.navWrapper.attr('id');
                    if (wrapperId && wrapperId.includes(state.uuid)) {
                        state.navWrapper.removeAttr('id');
                    }

                    state.navTrigger.removeAttr('aria-expanded aria-controls');
                    state.navTrigger.find('.icon').removeClass('icon-close').addClass('icon-burger');
                    state.navTrigger.find('.icon__label').text(settings.messages[locale].showMenu);
                    const triggerId = state.navTrigger.attr('id');
                    if (triggerId && triggerId.includes(state.uuid)) {
                        state.navTrigger.removeAttr('id');
                    }

                    state.navWrapper.find(`.${navElements.subnavItemClass}`).each(function (index) {
                        const $item = $(this);
                        const $label = $item.find(`.${navElements.subnavLabelClass}`);
                        const $panel = $item.find(`.${navElements.subnavPanelClass}`);
                        const labelId = $label.attr('id');
                        const panelId = $panel.attr('id');

                        // Nettoyage des ajouts ARIA/ID/classes et listener
                        $item.find(`.${navElements.subnavCloseButtonClass}`).off('click.dsHeader');
                        $item.removeClass(`${navElements.dropdownClass} ${navElements.accordionClass} show`);
                        
                        $label.removeAttr('data-target data-toggle aria-haspopup aria-expanded aria-controls');
                        $label.removeClass('collapsed');
                        if (labelId && labelId.includes(state.uuid)) {
                            $label.removeAttr('id');
                        }
                        
                        $panel.removeAttr('data-target aria-labelledby');
                        $panel.removeClass('dropdown-menu collapse');
                        if (panelId && panelId.includes(state.uuid)) {
                            $panel.removeAttr('id');
                        }
                    });

                    // Nettoyer les données
                    state.header.removeData('dsHeader');
                    state.header.removeData('dsHeaderInitialized');

                    // Réinitialiser l'état
                    state = null;
                }
            };

            // Stocker l'instance
            $header.data('dsHeader', api);
            $header.data('dsHeaderInitialized', true);
        }

        // Initialiser le plugin
        return this.each(init);
    };
})(jQuery);